import { FC } from 'react';

import { Accordion, VSpacingContainer } from '@hh.ru/magritte-ui';

import styles from './styles.less';

interface Props {
    title: string;
    description: string | string[];
}

const Item: FC<Props> = ({ title, description }) => (
    <Accordion borderRadius={24} padding={24} title={<p className={styles.itemTitle}>{title}</p>}>
        {Array.isArray(description) ? (
            <VSpacingContainer default={8}>
                {description.map((item, index) => (
                    <p key={index} className={styles.itemDescription}>
                        {item}
                    </p>
                ))}
            </VSpacingContainer>
        ) : (
            <p className={styles.itemDescription}>{description}</p>
        )}
    </Accordion>
);

export default Item;
